var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataForRanking = function SvgNoDataForRanking(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 156,
    viewBox: "0 0 267 156",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.502 31.9017C228.459 31.8748 228.414 31.8534 228.367 31.8377L136.23 1.41255C135.564 1.19253 135.125 2.09778 135.71 2.48482L169.156 24.6022C169.201 24.6322 169.251 24.6559 169.302 24.6727L262.139 54.7587C262.81 54.9762 263.243 54.0594 262.648 53.68L228.502 31.9017Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.502 31.9017C228.459 31.8748 228.414 31.8534 228.367 31.8377L136.23 1.41255C135.564 1.19253 135.125 2.09778 135.71 2.48482L169.156 24.6022C169.201 24.6322 169.251 24.6559 169.302 24.6727L262.139 54.7587C262.81 54.9762 263.243 54.0594 262.648 53.68L228.502 31.9017Z",
    fill: "#ECECEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7176 32.1967C35.4161 31.7741 36.1604 31.4322 36.9361 31.1777L92.5244 12.9378C97.6114 11.2686 100.8 18.3256 96.1855 21.0402C96.1851 21.0404 96.1848 21.0405 96.1844 21.0406L3.54279 52.0177C3.07279 52.1748 2.77211 51.5251 3.19612 51.2685L34.7176 32.1967Z",
    fill: "#ECECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7671 31.5607L131.952 0V95.5838L35.7671 127.746V31.5607Z",
    fill: "#ECECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7671 31.5607L131.952 0V95.5838L35.7671 127.746V31.5607Z",
    fill: "url(#paint0_linear_4062_30736)",
    fillOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7671 31.5607L131.952 0V95.5838L35.7671 127.746V31.5607Z",
    fill: "url(#paint1_linear_4062_30736)",
    fillOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 0V95.8844L228.438 125.642V31.8613Z",
    fill: "#ECECEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 0V95.8844L228.438 125.642V31.8613Z",
    fill: "url(#paint2_linear_4062_30736)",
    fillOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 0V95.8844L228.438 125.642V31.8613Z",
    fill: "url(#paint3_linear_4062_30736)",
    fillOpacity: 0.02
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 0V95.8844L228.438 125.642V31.8613Z",
    fill: "#ECECEC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 0V95.8844L228.438 125.642V31.8613Z",
    fill: "url(#paint4_linear_4062_30736)",
    fillOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 0V95.8844L228.438 125.642V31.8613Z",
    fill: "url(#paint5_linear_4062_30736)",
    fillOpacity: 0.02
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7671 31.5605L131.952 64.023V156L35.7671 127.746V31.5605Z",
    fill: "#ECECEC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7671 31.5605L131.952 64.023V156L35.7671 127.746V31.5605Z",
    fill: "url(#paint6_linear_4062_30736)",
    fillOpacity: 0.02
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7671 31.5605L131.952 64.023V156L35.7671 127.746V31.5605Z",
    fill: "url(#paint7_linear_4062_30736)",
    fillOpacity: 0.02
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7674 31.5605L131.952 64.023L106.627 101.872C105.428 103.663 103.184 104.438 101.135 103.768L14.113 75.3031C11.0947 74.3158 9.845 70.726 11.5977 68.0778L35.7674 31.5605Z",
    fill: "#ECECEC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7674 31.5605L131.952 64.023L106.627 101.872C105.428 103.663 103.184 104.438 101.135 103.768L14.113 75.3031C11.0947 74.3158 9.845 70.726 11.5977 68.0778L35.7674 31.5605Z",
    fill: "url(#paint8_linear_4062_30736)",
    fillOpacity: 0.08
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 64.0232V156L228.438 125.642V31.8613Z",
    fill: "#ECECEC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 64.0232V156L228.438 125.642V31.8613Z",
    fill: "url(#paint9_linear_4062_30736)",
    fillOpacity: 0.05
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 64.0232V156L228.438 125.642V31.8613Z",
    fill: "url(#paint10_linear_4062_30736)",
    fillOpacity: 0.05
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 64.0232L158.462 101.415C159.679 103.132 161.87 103.858 163.872 103.207L250.573 75.0294C253.628 74.0363 254.87 70.3839 253.052 67.7347L228.438 31.8613Z",
    fill: "#ECECEC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.438 31.8613L131.953 64.0232L158.462 101.415C159.679 103.132 161.87 103.858 163.872 103.207L250.573 75.0294C253.628 74.0363 254.87 70.3839 253.052 67.7347L228.438 31.8613Z",
    fill: "url(#paint11_linear_4062_30736)",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4062_30736",
    x1: 83.8596,
    y1: 0,
    x2: 83.8596,
    y2: 127.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4062_30736",
    x1: 131.952,
    y1: 63.8728,
    x2: 35.7671,
    y2: 63.8728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4062_30736",
    x1: 180.195,
    y1: 0,
    x2: 180.195,
    y2: 125.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4062_30736",
    x1: 228.438,
    y1: 62.8208,
    x2: 131.953,
    y2: 62.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4062_30736",
    x1: 180.195,
    y1: 0,
    x2: 180.195,
    y2: 125.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4062_30736",
    x1: 228.438,
    y1: 62.8208,
    x2: 131.953,
    y2: 62.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4062_30736",
    x1: 83.8596,
    y1: 31.5605,
    x2: 83.8596,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4062_30736",
    x1: 131.952,
    y1: 93.7802,
    x2: 35.7671,
    y2: 93.7802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4062_30736",
    x1: 53.8021,
    y1: 52.3004,
    x2: 61.9177,
    y2: 113.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4062_30736",
    x1: 180.195,
    y1: 31.8613,
    x2: 180.195,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4062_30736",
    x1: 131.953,
    y1: 93.9307,
    x2: 228.438,
    y2: 93.9307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4062_30736",
    x1: 182.149,
    y1: 91.0752,
    x2: 284.947,
    y2: 145.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataForRanking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-for-ranking.77f2d920.svg";
export { ForwardRef as ReactComponent };